import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { marketService } from 'shared/src/api';

export const useMarketRankingFilterOptions = (marketTypeSno: number) => {
  return useSuspenseQuery({
    queryKey: queryKey.marketRankingFilterOptions(marketTypeSno),
    queryFn: () => marketService.getMarketRankingFilterOptions(marketTypeSno),
  });
};
